import React from "react"
import { components, GroupBase, OptionProps, SingleValueProps } from "react-select"

import { UITypes } from "types"

import { SelectStatic, SelectStaticProps } from "../SelectStatic"

import styles from "./index.module.scss"

const ColorOption = (props: OptionProps<UITypes.Option, boolean, GroupBase<UITypes.Option>>): React.JSX.Element => {
  const { data, innerRef, innerProps } = props
  const color = data.color || "initial"

  return (
    <div ref={innerRef} {...innerProps} className={styles.colorOption}>
      <span style={{ color }}>{data.label}</span>
    </div>
  )
}

const ColorSingleValue = (props: SingleValueProps<UITypes.Option, boolean, GroupBase<UITypes.Option>>) => {
  const { data } = props
  const color = data?.color || "initial"

  return (
    <components.SingleValue {...props} className={styles.colorSingleValue}>
      <span style={{ color }}>{data?.label}</span>
    </components.SingleValue>
  )
}

export const SelectWithColor = (props: SelectStaticProps) => {
  return <SelectStatic {...props} optionRenderer={ColorOption} singleValueRenderer={ColorSingleValue} />
}
